import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spinner } from "react-bootstrap";
import {
  useGetFarmersQuery,
  useMultipleReportDownloadMutation,
} from "./farmerApiSlice";
import { DataGrid } from "@mui/x-data-grid";
import StateDistrict from "./StateDistrict";
import CustomSearchBar from "components/CustomSearchBar";
import Pagination from "@mui/material/Pagination";
import { toast } from "react-toastify";
import { API_URL } from "app/config";
import { store } from "app/store";
import { Table } from "reactstrap";
export const FarmerTemplateDownload = ({ setAssignOption, orgId }) => {
  const [selectedFarmerIds, setSelectedFarmerIds] = useState([]);
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [farmerRows, setfarmerRows] = useState([]);
  const [multipleDownloadFarmers] = useMultipleReportDownloadMutation();
  const [plots, setPlots] = useState("");
  const [type, setType] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    pageCount: 0,
    per_page: 50,
  });

  const { data: farmerData, isLoading: farmerLoading } = useGetFarmersQuery(
    {
      pagination,
      orgId,
      stateId: state_id,
      districtId: district_id,
      searchKey: debouncedSearch || "",
    },
    { refetchOnMountOrArgChange: true }
  );
  const [showDownloads, setShowDownloads] = useState(false);
  const [reportingData, setReportingData] = useState([]);

  useEffect(() => {
    const paginationFromApi = farmerData?.data?.pages
      ? {
          page: farmerData?.data?.current_page,
          pageCount: farmerData?.data?.pages,
          per_page: farmerData?.data?.per_page,
        }
      : pagination;
    setPagination(paginationFromApi);
    setfarmerRows(farmerData?.data?.results ? farmerData?.data?.results : []);
  }, [farmerData]);

  const columns = [
    { field: "full_name", headerName: "Name", width: 150 },
    {
      field: "created_at",
      headerName: "Onboarding Date",
      width: 150,
      renderCell: (cellvalues) => cellvalues.row.created_at?.slice(0, 10) || "",
    },
    { field: "phone_number", headerName: "Mobile", width: 120 },
    { field: "gender", headerName: "Gender", width: 80 },
    { field: "age", headerName: "Age", width: 50 },
    {
      field: "farmer_category",
      headerName: "Category",
      width: 200,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "14px" }} title={row.farmer_category}>
          {(row.farmer_category || "").length > 50
            ? `${row.farmer_category.substring(0, 50)}...`
            : row.farmer_category}
        </div>
      ),
    },
    {
      field: "total_land_holding",
      headerName: "Declared Landholding",
      width: 110,
      renderCell: ({ row }) =>
        `${row.total_land_holding} ${row.unit_of_land_holding || ""}`,
    },
    {
      field: "total_acs",
      headerName: "ACS",
      width: 100,
      renderCell: ({ row }) => row.total_acs?.toFixed(2),
    },
    { field: "state_name", headerName: "State Name", width: 130 },
    {
      field: "district_name",
      headerName: "District Name",
      width: 140,
      renderCell: ({ row }) => (
        <div style={{ fontSize: "13px" }} title={row.district_name}>
          {(row.district_name || "").length > 50
            ? `${row.district_name.substring(0, 50)}...`
            : row.district_name}
        </div>
      ),
    },
  ];

  const onLocationChange = (event) => {
    if (event.ConditionName === "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName === "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName === "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const reportBulkData = async () => {
    const responseData = {
      template_type: type ? type : "complete",
      organisation_id:orgId,
      farmer_detail: selectedFarmerIds?.map((f) => ({
        farmer_id: f,
        no_of_plots: plots ? plots : 1,
      })),
    };
    multipleDownloadFarmers(responseData)
      .unwrap()
      .then((data) => {
        toast.success("Task Created");
      })
      .catch((error) => {
        toast.error("Error while Uploading Farmer");
        return;
      });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500);
    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (value) => {
    setSearchKey(value);
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
  };

  const filterDataBasedId = (item) => {
    setSelectedFarmerIds(item);
  };
  const CustomPagination = () => {
    return (
      <Pagination
        color="primary"
        count={pagination?.pageCount}
        page={pagination?.page}
        onChange={(event, value) => {
          setPagination({
            page: value,
            pageCount: pagination?.pageCount,
            perPage: pagination.perPage,
          });
        }}
        variant="outlined"
        shape="rounded"
      />
    );
  };
  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const state = store.getState();
        const url = `${API_URL}/reporting/api/acs/reports/`;
        const response = await fetch(url, {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        setReportingData(data?.data);
        console.log("data", data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    if (showDownloads) {
      fetchDashboard();
    }
  }, [showDownloads]);
  const handleDownload = (fileUrl) => {
    if (!fileUrl) return;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  console.log("reportingData", reportingData);
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-center gap-2 mb-3">
        <Button
          size="sm"
          variant={showDownloads ? "outline-warning" : "warning"}
          onClick={() => setShowDownloads(false)}
        >
          Download Report
        </Button>

        <Button
          size="sm"
          variant={showDownloads ? "warning" : "outline-warning"}
          onClick={() => setShowDownloads(true)}
        >
          Downloads
        </Button>
      </div>

      {!showDownloads ? (
        <>
          <Row style={{ backgroundColor: "#f8f8f8" }}>
            <Col md={2} className="mt-3">
              <CustomSearchBar sendSearchFunction={handleChangeSearch} />
            </Col>
            <Col md={10}>
              <StateDistrict
                onLocationChange={onLocationChange}
                state_id={state_id}
                district_id={district_id}
                block_id={block_id}
                stateName={stateName}
                districtName={districtName}
                blockName={blockName}
                setBlockList={setBlockList}
                blockList={blockList}
                noBlock={true}
                setStateName={setStateName}
                setDistrictName={setDistrictName}
                setStateId={setStateId}
                setDistrictId={setDistrictId}
              />
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center my-3">
            <h5 className="mb-0">Select Farmers</h5>
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                style={{ minWidth: "120px" }}
                value={plots}
                onChange={(e) => setPlots(e.target.value)}
              >
                <option value="">Plots</option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>

              <select
                className="form-select form-select-sm"
                style={{ minWidth: "150px" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Type</option>
                <option value="complete">Complete</option>
                <option value="historical">Historical</option>
                <option value="current">Current</option>
              </select>

              <Button variant="success" size="sm" onClick={reportBulkData}>
                Submit
              </Button>
            </div>
          </div>

          {farmerLoading ? (
            <div className="d-flex flex-column justify-content-center align-items-center py-5">
              <Spinner
                animation="border"
                variant="primary"
                role="status"
                style={{ width: "2rem", height: "2rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <div className="mt-3">
                <strong>Loading farmer data...</strong>
              </div>
            </div>
          ) : (
            <DataGrid
              rows={farmerRows}
              columns={columns}
              rowsPerPageOptions={[3]}
              checkboxSelection
              keepNonExistentRowsSelected
              onRowSelectionModelChange={(item) => {
                filterDataBasedId(item);
              }}
              components={{
                Pagination: CustomPagination,
              }}
            />
          )}
        </>
      ) : (
        <Table striped hover>
          <thead>
            <tr>
              <th className="th-sm">Status</th>
              <th className="th-sm">Time</th>
              <th className="th-sm">File</th>
            </tr>
          </thead>
          <tbody>
            {reportingData?.map((field, index) => (
              <tr key={index}>
                <td>{field.status}</td>
                <td>{field.timestamp?.slice(0, 10)}</td>
                <td>
                  <Button
                    size="sm"
                    className="text-warning"
                    onClick={() => handleDownload(field.file_url)}
                  >
                    <i
                      className="mdi mdi-download"
                      style={{ color: "white" }}
                    ></i>
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};
